<template>
    <v-form v-model="valid">
        <v-container fluid>
            <v-row>
                <v-col cols="12" md="3">
                    <v-text-field v-model="criterio.idLink" label="ID"></v-text-field>
                </v-col>

                <v-col cols="12" md="3">
                    <v-autocomplete v-model="criterio.idEstado"
                                    item-text="descripcion"
                                    item-value="id"
                                    :items="estados"
                                    label="Seleccione un estado"
                                    autocomplete="off">
                    </v-autocomplete>
                </v-col>

                <v-col cols="12" md="3">
                    <v-text-field v-model="criterio.descripcion" label="Descripcion"></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                    <v-text-field v-model="criterio.palabraClave" label="Palabra Clave"></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                    <v-text-field v-model="criterio.url" label="Dirección"></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                    <v-text-field v-model="criterio.titulo" label="Título del libro"></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                    <v-text-field v-model="criterio.creador" label="Autor"></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                    <v-autocomplete v-model="criterio.idTipo"
                                    item-text="departamento"
                                    item-value="id"
                                    :items="tiposEditorial"
                                    label="Seleccione un tipo"
                                    autocomplete="off">
                    </v-autocomplete>
                </v-col>
                <v-col cols="12" md="3">
                    <v-text-field v-model="criterio.numVisitas" label="Visitas"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-btn color="primary right" dark @click="buscarEnlaces(criterio)">BUSCAR</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';

    export default {
        name: 'Filtro',
        props: ['criterio'],
        data() {
            return {
                valid: true
            }
        },
        computed: {
            ...mapState(['estados']),
            ...mapGetters(['tiposEditorial'])

        },
        methods: {
            buscarEnlaces(item) {
                this.$emit('buscarEnlaces', item)
            }
        }
    }
</script>

<style>
    .v-input.v-text-field {
        margin-top: 0;
        padding-top: 0;
    }

    .right {
        float: right;
    }
</style>